import {
  getGrammarPosition,
  getParaphrasePosition,
} from '@chegg-wt/core/utils/paraphraser/helpers'
import { Feedback } from '@chegg-wt/core/types/paraphraser'
import getFeatureEditor from '@chegg-wt/core/utils/paraphraser/getEditor'
import { FeedbackTab } from '@chegg-wt/core/constants/paraphraser'
import fullPaperChecker from '@chegg-wt/core/utils/paraphraser/pusherDataHandlers/fullPaperCheckHandler'
import { CheckTypeInput } from '@chegg-wt/core/globalTypesOneGraph'
import { store } from '..' // ? will need store dispatch, logic dispatch does not work for pusher subscribed events
import { PusherGrammarFeedback, PusherParaphraseFeedback, WtPusherEvent } from './types'
import { appendFeedback } from './actions'
import { activeFeedbackTabSelector, sentenceOffsetsSelector } from './selectors'

export const handlePusherGrammarEvent = (
  eventData: WtPusherEvent<PusherGrammarFeedback>
) => {
  const { dispatch, getState } = store
  const editor = getFeatureEditor()
  const state = getState()
  const sentenceOffsets = sentenceOffsetsSelector(state)
  const isGrammarTabActive = activeFeedbackTabSelector(state) === FeedbackTab.GRAMMAR_TAB

  const grammarFeedbacks: Feedback[] = eventData.feedback.suggestions.map(
    (grammarSuggestion) => ({
      id: grammarSuggestion.id,
      sentenceId: eventData.sentence.id,
      feedbackType: eventData.feedback.feedbackType,
      changeType: grammarSuggestion.changeType,
      position: grammarSuggestion.position,
      suggestedText: grammarSuggestion.suggestedText,
    })
  )

  // add to feedback
  dispatch(appendFeedback(grammarFeedbacks))
  // todo - sort feedback on every event. quick sort as sorting is to be done on multiple elements in one go

  // update underline if grammar tab active
  if (isGrammarTabActive) {
    grammarFeedbacks.forEach((grammarFeedback) => {
      const { offset, length } = getGrammarPosition(grammarFeedback, sentenceOffsets)

      editor.commands.setCustomUnderline({
        id: grammarFeedback.id,
        offset,
        length,
        type: grammarFeedback.feedbackType,
      })
    })
  }
}

export const handlePusherParaphraseEvent = (
  eventData: WtPusherEvent<PusherParaphraseFeedback>
) => {
  const { dispatch, getState } = store
  const state = getState()
  const sentenceOffsets = sentenceOffsetsSelector(state)

  // Not consider paraphrase ifwe don't get any sentnce or sentence is same
  const sentence = sentenceOffsets.find(
    (sentence) => sentence.id === eventData.sentence.id
  )
  if (
    !eventData.feedback.suggestedText ||
    eventData.feedback.suggestedText === sentence?.originalText
  )
    return

  const isParaphraseTabActive =
    activeFeedbackTabSelector(state) === FeedbackTab.PARAPHRASE_TAB

  const editor = getFeatureEditor()

  // handle paraphrase feedback
  const newFeedback: Feedback = {
    id: eventData.feedback.id,
    sentenceId: eventData.sentence.id,
    feedbackType: eventData.feedback.feedbackType,
    suggestedText: eventData.feedback.suggestedText,
  }
  // add to feedback
  dispatch(appendFeedback([newFeedback]))
  // todo - sort feedback on every event. insertion sort as one only element to be placed in already sorted array

  // update underline based on active tab
  if (isParaphraseTabActive) {
    const { offset, length } = getParaphrasePosition(newFeedback, sentenceOffsets)

    editor.commands.setCustomUnderline({
      id: newFeedback.id,
      offset,
      length,
      type: newFeedback.feedbackType,
    })
  }
}

export const handlePusherEventData = (eventData: WtPusherEvent) => {
  const { dispatch } = store
  if (eventData.checkType === CheckTypeInput.FULL) {
    fullPaperChecker.handleFeedbackEvent(eventData, dispatch)
  }
}
